import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useAuth} from './core/Auth'
import {clearProactiveRefresh} from './core/TokenRefresh'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    clearProactiveRefresh()
    logout()
    document.location.reload()
  }, [logout])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
